import React, { useEffect, useState } from 'react'

const TipsTricksVideo = ({
    openModal,
    onClose,
    videoObj,
}) => {

    const [iframeDimensions, setIframeDimensions] = useState({ width: 560, height: 289 });

    const calculateIframeSize = () => {
        const screenWidth = window.innerWidth;
        let width, height;
        if (screenWidth >= 1100) {
            width = 1080;
            height = 558;
        } else if (screenWidth >= 780) {
            width = 780;
            height = 403;
        } else if (screenWidth >= 560) {
            width = 560;
            height = 289;
        } else {
            width = 320;
            height = 165;
        }
        setIframeDimensions({ width, height });
    };

    useEffect(() => {
        // Adjust iframe size on window resize
        calculateIframeSize();
        window.addEventListener("resize", calculateIframeSize);

        return () => {
            window.removeEventListener("resize", calculateIframeSize);
        };
    }, []);

    if (!openModal) return null;

    return (
        <div
            className='position-fixed d-flex align-items-center justify-content-center'
            style={{
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgb(36 31 31 / 80%)",
                zIndex: 1000,
            }}
            onClick={onClose}
        >
            <button
                onClick={onClose}
                className='cursor-pointer text-white position-absolute font-w600'
                style={{
                    top: "15px",
                    right: "15px",
                    background: "transparent",
                    border: "none",
                    fontSize: "40px",
                }}
            >
                &times;
            </button>

            <div
                className='position-relative overflow-hidden d-flex align-items-center justify-content-center'
                style={{
                    // position: "relative",
                    // backgroundColor: "white",

                    // overflow: "hidden",
                    // boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    data-video-id={videoObj?.dataVideoId}
                    style={{
                        aspectRatio: videoObj?.aspectRatio,
                        overflow: 'hidden',
                        minWidth: '85vw',
                        minHeight: '60vh',
                        borderRadius: "10px",
                        boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
                    }}
                >
                    <iframe
                        width="100%"
                        height="100%"
                        src={videoObj?.url}
                        title={videoObj?.title}
                        style={{ aspectRatio: videoObj?.aspectRatio, overflow: 'hidden' }}
                        frameborder="0"
                        scrolling="no"
                        allow="fullscreen"
                    ></iframe>
                </div>


                {/* <div
                    style={{
                        width: `${iframeDimensions.width}px`,
                        height: `${iframeDimensions.height}px`,
                    }}
                >
                    <iframe
                        width={iframeDimensions.width}
                        height={iframeDimensions.height}
                        src={url}
                        title="Chilll Signup"
                        frameBorder="0"
                        scrolling="no"
                        allow="fullscreen"
                        style={{ borderRadius: "10px" }}
                    ></iframe>
                </div> */}
            </div>
        </div>
    )
}

export default TipsTricksVideo